// extracted by mini-css-extract-plugin
export default {"root":"checkbox_root__CR0PD","md":"checkbox_md__fGN91","lg":"checkbox_lg__KGmfM"};